<template>
  <b-modal
      modal-class="footer-dialog"
      data-test-path="dialog-select-in-combo"
      id="bv-modal-date"
      :title="title"
      @hide="onHide"
      @ok="onOk"
      ref="modal"
  >
    <b-container class="px-3 mx-0" fluid="true">
      <b-row>
        <b-col cols="6">
          <DateTimePicker
              data-test-path="start-date"
              v-model="startDateValue"
              date-type="LocalDate"
              format="L"
              :label="tr('startDate','Start Date')"
              :validated-field="startDate"
          >
          </DateTimePicker>

        </b-col>
        <b-col cols="6">
          <DateTimePicker
              data-test-path="end-date"
              v-model="endDateValue"
              date-type="LocalDate"
              format="L"
              :label="tr('endDate','End Date')"
              :validated-field="endDate"
          >
          </DateTimePicker>
        </b-col>
      </b-row>
      <b-row v-if="dateErrorMessage && startDateValue && endDateValue">
        <b-col>
          <small class="form-text text-danger pt-2">
            {{tr('dataDialog.date.earlier','End date cannot be earlier than the starting date.')}}
          </small>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer="{close}">
        <FooterNavbar data-test-path="select-in-data-grid-footer" class="w-100 m-0 text-center">
          <footer-button type="Cancel" @cancel="cancel"></footer-button>
          <FooterButton type="Ok"  @ok="onOk" :disabled="(dateErrorMessage && startDateValue !== null && endDateValue !== null)
          || (startDateValue === null && endDateValue === null)"></FooterButton>
        </FooterNavbar>
    </template>
  </b-modal>
</template>

<script>
import FooterNavbar from "@/components/navbar/FooterNavbar";
import VBox from "@/components/VBox";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import DateTimePicker from "@/components/inputs/DateTimePicker";
import moment from "moment-timezone";
import tr from "@/utils/Tr";

moment.suppressDeprecationWarnings = true;

export default {
  name: "DateDialog",
  components: {DateTimePicker, FooterButton, VBox, FooterNavbar, CloseButton},

  methods: {
    tr,

    async onHide(ev) {
      if (this.resolve != null) {
        this.resolve(null);
        this.resolve = null;
      }
    },

    async onOk() {
      if(this.resolve != null){
        this.resolve({"startDate" : this.startDateValue, "endDate": this.endDateValue});
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },

    async cancel() {
      this.$refs.modal.hide();
    },


    reset(){
      this.startDateValue = null;
      this.endDateValue = null;
      this.result = null;
      this.resolve = null;
    },


  },

  watch: {
    startDateValue: async function (val) {
      this.dateErrorMessage = moment(val?.value).isAfter(moment(this.endDateValue?.value));
    },
    endDateValue: async function (val) {
      this.dateErrorMessage = moment(val?.value).isBefore(moment(this.startDateValue?.value));
    },
  },

  data: () => ({
    dateErrorMessage: false,
    title: "",
    resolve: null,
    result: null,
    startDate: null,
    startDateValue: null,
    endDate: null,
    endDateValue: null,
  })
}
</script>
